import {isDev} from '@zzng/common/utils/common';

const APP_KEY = isDev ? 'a152202004db58a2c60546c0dc7280b9' : '24b80574b62fafaab913db48018ad898';

const TEMLATE_IDS = {
  BENEFIT: {
    dev: 2657,
    prod: 107220
  },
  BENEFIT_DETAIL: {
    dev: 2659,
    prod: 107221
  },
  DICARON_CARD: {
    dev: 3179,
    prod: 114552
  }
} as const;

type TemplateKey = keyof typeof TEMLATE_IDS;

type TemplateArgs = {
  BENEFIT: {EVENT_URL: string};
  BENEFIT_DETAIL: {EVENT_URL: string; DESCRIPTION?: string; IMAGE_URL?: string; BUTTON?: string; TITLE?: string};
  DICARON_CARD: {INTRO_URL: string; IMAGE_URL: string; CARD_TITLE: string};
};

export const sendTMS = <T extends TemplateKey>(key: T, templateArgs: TemplateArgs[T]) => {
  if (!window.navigator.onLine) {
    return;
  }

  if (!window.Kakao?.isInitialized()) {
    window.Kakao?.init(APP_KEY);
  }

  const settings = {
    templateId: TEMLATE_IDS[key][isDev ? 'dev' : 'prod'],
    installTalk: true,
    templateArgs
  };

  window.Kakao?.Share.sendCustom(settings);
};
